<div class="row datarow shadow font-size-14" [ngClass]="{'item-height':!autoHeight}">
    <ng-content></ng-content>
</div>